'use client';

import React, { useContext, useMemo } from 'react';
import { getCookie } from 'cookies-next';
import { getAllowedPermissions } from '@/helpers/utils/siteUtils';
import { COOKIE_KEYS } from '../../../constants/constant';

export interface ProjectSettingsContextShape {
  projectSettings?: any;
}
export const ProjectSettingsContext = React.createContext({} as ProjectSettingsContextShape);

const ProjectSettingsProvider = ({
  projectSettings,
  children,
}: React.PropsWithChildren<ProjectSettingsContextShape>) => {
  const contextValue = useMemo(() => {
    const agentRole = getCookie(COOKIE_KEYS.agentRole) as string;
    const caseNumber = getCookie(COOKIE_KEYS.caseNumber) as string;
    const caseId = getCookie(COOKIE_KEYS.caseId) as string;
    const allowedPermissionsForAgent = getAllowedPermissions(agentRole, projectSettings?.agentRolesConfig as string);
    const { allowedCreditSites, agentRolesConfig, ...restProjectSettings } = projectSettings;
    return {
      projectSettings: {
        ...restProjectSettings,
        allowedPermissionsForAgent,
        caseNumber,
        caseId,
        allowedCreditSites,
      },
    };
  }, [projectSettings]);
  return <ProjectSettingsContext.Provider value={contextValue}>{children}</ProjectSettingsContext.Provider>;
};

export default ProjectSettingsProvider;

export const useProjSettings = () => {
  const { projectSettings } = useContext(ProjectSettingsContext);
  return projectSettings;
};
